import {LayerImagery, LayerLoadType, MapperViewer} from '../../types';

export class ZmfLayer implements LayerImagery {

  id = 'zmf';
  name = 'Zonage ONF';
  active = true;
  imageryLayer = new Cesium.ImageryLayer(new Cesium.WebMapServiceImageryProvider({
    url: 'https:///mapserver-zmf.predictlayers.pw/mapserv?',
    layers: 'zmf',
    parameters: {
      service: 'WMS',
      version: '1.3.0',
      request: 'GetMap',
      styles: '',
      format: 'image/png',
      transparent: true,
      width: 512,
      height: 512
    },
    tilingScheme: new Cesium.GeographicTilingScheme(),
    maximumLevel: 18,
  }));
  loadType: LayerLoadType;
  viewer: MapperViewer;
  showLabel = false;

  initialize(viewer: MapperViewer): void {
    this.viewer = viewer;
    this.imageryLayer.alpha = 0.5;
    viewer.imageryLayers.add(this.imageryLayer);
  }

  remove(): void {
    this.viewer.imageryLayers.remove(this.imageryLayer, false);
  }

  loadData(): void {}

  setActive(active: boolean): void {
    this.active = active;
    this.imageryLayer.show = active;
  }

  onAfterPrint(): void {
  }

  onBeforePrint(): void {
  }
}
